import React, { Component } from "react";
import DatePicker from "react-datepicker";
import _ from "lodash";
import { CSVLink } from "react-csv";
import moment from "moment";

// Configs
import { endpoints } from "../../../../configs";

// API call
import { apiClient } from "../../../../apiClient";

//Assets
import { DownloadIcon } from "../../../../assets/img/icons";

// Action
import { fetchList } from "../../../../actions/table";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Components
import PageTitle from "../../../../components/base/PageTitle";
import ReduxTable, {
  ReduxColumn
} from "../../../../components/base/ReduxTable";
import { REFERRAL_LINK_CLICKED } from "../../../../reports/Constants";

// 404 Page
import Page404 from "../../../Page404";
import { isBadRequest } from "../../../../common/http";
import PageSearch from "../../../../components/base/PageSearch";
import Terminology from "../../../../lib/Terminology";
import SystemName from "../../../../Constants/SystemName";

class LinkTracking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPageNotFound: false,
      startDate: "",
      endDate: "",
      status: "",
      searchTerm: "",
      partnerActivityReportCsv: []
    };
  }
  componentDidMount() {
    this._getActivityReportDetails();
  }
  // Activity details api call
  _getActivityReportDetails = params => {
    return apiClient
      .get(`${endpoints().activity}?${params && params.join("&")}`)
      .then(response => {
        const activityData = [];
        response.data.data.forEach(data => {
          if (data && data.activity_type === REFERRAL_LINK_CLICKED) {
            activityData.push({
              companyName: data.companyName,
              activity_type: data.activity_type,
              createdAt: data.createdAt,
              notes: data.notes
            });
          }
        });
        this.setState({
          partnerActivityReportCsv: activityData,
          loading: false
        });
      })
      .catch(error => {
        if (isBadRequest(error)) {
          let errorMessage;
          const errorRequest = error.response.request;
          if (errorRequest && errorRequest.response) {
            errorMessage = JSON.parse(errorRequest.response).message;
          }
          console.error(errorMessage);
        }
      });
  };

  /**
   * Change search term
   *
   * @param {*} event
   */
  onChange(event) {
    event.persist();
    const value = event.target.value;
    this.setState({ searchTerm: decodeURI(value) });
    this.doSearch(event);
  }

  doSearch = _.debounce(event => {
    this.setState(
      {
        isSearch: true,
        searchTerm: encodeURIComponent(event.target.value),
        page: 1
      },
      () => {
        this.fetchData();
        this.updateUrl();
      }
    );
  }, 500);

  //Hanlde Start Date Function
  handleStartDate = startDate => {
    this.setState({ startDate: startDate ? startDate : "" }, () => {
      this.fetchData();
      this.updateUrl();
    });
  };

  //Hanlde End Date Function
  handleEndDate = endDate => {
    this.setState({ endDate: endDate ? endDate : "" }, () => {
      this.fetchData();
      this.updateUrl();
    });
  };

  //Fetch API Data
  fetchData = () => {
    const { startDate, endDate, searchTerm } = this.state;
    const params = [];
    if (searchTerm) {
      params.push(`search=${searchTerm}`);
    }
    if (startDate) {
      params.push(`startDate=${startDate.toLocaleDateString("en-US")}`);
    }
    if (endDate) {
      params.push(`endDate=${endDate.toLocaleDateString("en-US")}`);
    }
    this._getActivityReportDetails(params);

    this.props.actions.fetchList(
      "linkTracking",
      `${endpoints().activity}`,
      1,
      10,
      {
        startDate,
        endDate,
        search: searchTerm,
        pagination: true,
        linkTracking: true
      }
    );
  };

  //Update URL query
  updateUrl() {
    const { searchTerm, startDate, endDate } = this.state;
    const params = [];

    if (searchTerm) {
      params.push(`search=${searchTerm}`);
    } else {
      params.push(`search=${""}`);
    }
    if (startDate) {
      params.push(`startDate=${startDate.toLocaleDateString("en-US")}`);
    }
    if (endDate) {
      params.push(`endDate=${endDate.toLocaleDateString("en-US")}`);
    }
    if (params.length > 0) {
      this.props.history.push(
        `/reports/referral-link-tracking-activity-report/?${params.join("&")}`
      );
    }
  }

  render() {
    const { searchTerm, partnerActivityReportCsv } = this.state;

    const headers = [
      { label: "Partner", key: "companyName" },
      { label: "Destination Name", key: "notes" },
      { label: "Link Clicked (UTC)", key: "createdAt" }
    ];

    // Page Not Found
    if (this.state.isPageNotFound) {
      return <Page404 />;
    }

    return (
      <div>
        {/* Page Title */}
        <PageTitle
          label={`${Terminology.get(
            SystemName.REFERRAL
          )} Link Tracking Activity Report`}
        />
        <div>
          <div className={`page-heading cover`}>
            <div className="d-flex justify-content-between">
              <div>
                <PageSearch
                  classnames="page-search"
                  placeholder="Search Partner Name"
                  onChange={this.onChange.bind(this)}
                  width="250px"
                />
              </div>
              <div className="datepicker-wrapper py-1 mr-3">
                {/* Start Date */}
                <DatePicker
                  name="startDate"
                  className="datepicker"
                  placeholderText="Start Date"
                  onChange={this.handleStartDate}
                  maxDate={new Date(this.state.endDate)}
                  selected={this.state.startDate}
                  clearIcon={null}
                />
              </div>
              <div className="datepicker-wrapper py-1 mr-3">
                {/* End Date */}
                <DatePicker
                  name="endDate"
                  className="datepicker"
                  placeholderText="End Date"
                  onChange={this.handleEndDate}
                  minDate={new Date(this.state.startDate)}
                  selected={this.state.endDate}
                  clearAriaLabel
                  clearIcon={null}
                  width={"150px"}
                />
              </div>
              <div className="mt-2">
                <CSVLink
                  data={partnerActivityReportCsv}
                  headers={headers}
                  filename={`Partner_Link_Tracking_Activities${moment().format(
                    "YYYY-MM-DD"
                  )}.csv`}
                >
                  <span className="download-pdf ml-auto d-flex" href="#">
                    <DownloadIcon />
                    <span className="ml-1">Export</span>
                  </span>
                </CSVLink>
              </div>
            </div>
          </div>
          <ReduxTable
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            id="linkTracking"
            apiURL={`${endpoints().activity}`}
            newTableHeading
            params={{
              search: searchTerm ? searchTerm : "",
              linkTracking: true
            }}
            paramsToUrl={true}
            history={this.props.history}
          >
            <ReduxColumn field="companyName" sortBy="companyName">
              Partner
            </ReduxColumn>
            <ReduxColumn field="notes" sortBy="notes">
              Destination Name
            </ReduxColumn>
            <ReduxColumn field="createdAt" sortBy="createdAt">
              Link Clicked (UTC)
            </ReduxColumn>
          </ReduxTable>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchList }, dispatch)
  };
}

export default connect(() => {
  return {};
}, mapDispatchToProps)(LinkTracking);
